import "parsleyjs";
import "parsleyjs/dist/i18n/pt-br";
import "jquery-mask-plugin";

class Test {
  constructor() {
    this.form();
  }

  form() {
    // REMOVE LATER
    // const $form = $("#test-form");
    // const testForm = $form.parsley();
    // const $comingFrom = $('input[name="coming_from"]');

    // $form.on("submit", (e) => {
    //   e.preventDefault();

    //   if (testForm.isValid()) {
    //     const $formButton = $form.find("button");
    //     const $recaptchaField = $('[name="recaptcha_token"]');
    //     grecaptcha.ready(() => {
    //       $formButton.attr("disabled", true);
    //       grecaptcha
    //         .execute(recaptchaToken, { action: $recaptchaField.data("action") })
    //         .then((token) => {
    //           $recaptchaField.val(token);
    //           $formButton.attr("disabled", false);
    //           $form.off("submit").submit();
    //         });
    //     });
    //   } else {
    //     return false;
    //   }
    // });

    // if ($comingFrom.length) {
    //   const $partnerCode = $(".partner_code");
    //   const $reason = $(".reason");
    //   $comingFrom.on("change", function () {
    //     const coming = $(this).val();
    //     $reason.find("label").text("Por favor, escreva como nos conheceu");

    //     switch (coming) {
    //       case "hospedin_partner":
    //         $partnerCode.removeClass("d-none").addClass("d-block");
    //         $reason.removeClass("d-block").addClass("d-none");
    //         break;
    //       case "recommendation":
    //         $reason.removeClass("d-none").addClass("d-block");
    //         $partnerCode.removeClass("d-block").addClass("d-none");
    //         $reason.find("label").text("Por favor, escreva quem indicou você");
    //         break;
    //       case "other_coming":
    //         $reason.removeClass("d-none").addClass("d-block");
    //         $partnerCode.removeClass("d-block").addClass("d-none");
    //         break;
    //       default:
    //         $reason.removeClass("d-block").addClass("d-none");
    //         $partnerCode.removeClass("d-block").addClass("d-none");
    //     }

    //     $partnerCode.find("input").val("");
    //     $reason.find("input").val("");
    //   });
    // }

    const $newsletterForms = $(".js-newsletter-form");
    const recaptchaWidgets = new Map();

    const renderNewsletterRecaptcha = () => {
      if (!window.grecaptcha || !window.grecaptcha.render) return;

      $newsletterForms.each(function () {
        const container = $(this).find(".js-newsletter-recaptcha")[0];
        if (!container || !container.dataset.sitekey || recaptchaWidgets.has(this)) return;

        recaptchaWidgets.set(
          this,
          window.grecaptcha.render(container, {
            sitekey: container.dataset.sitekey,
            theme: container.dataset.theme || "light",
          })
        );
      });
    };

    window.onNewsletterRecaptchaLoad = renderNewsletterRecaptcha;
    renderNewsletterRecaptcha();

    $newsletterForms.each(function () {
      const form = this;
      const $form = $(form);
      const $message = $("#newsletter-message");
      const $button = $form.find(".js-newsletter-submit");
      const field = (name) => $form.find(`[name="${name}"]`);

      const showMessage = (text, color) => {
        $message
          .empty()
          .append(
            $("<div>")
              .addClass(`col-12 col-lg-6 rounded-pill ${color} white my-4 py-2 text-center`)
              .text(text)
          );
      };

      const fieldsAreValid = () =>
        $form
          .find("input[required], input[type=email]")
          .toArray()
          .every((input) => input.reportValidity());

      const submit = () => {
        if (!fieldsAreValid()) return;

        const widget = recaptchaWidgets.get(form);
        const token = widget === undefined ? "" : window.grecaptcha.getResponse(widget);

        if (!token) {
          showMessage("Confirme que você não é um robô.", "bg-red");
          return;
        }

        $message.empty();
        $button.attr("disabled", true);

        $.ajax({
          url: $form.data("url"),
          method: "POST",
          headers: {
            ["X-CSRF-Token"]: document.querySelector('[name="csrf-token"]').content,
          },
          data: {
            name: field("name").val(),
            company: field("company").val(),
            email: field("email").val(),
            website: field("website").val(),
            recaptcha_token: token,
          },
        })
          .done(() => {
            field("name").val(null);
            field("company").val(null);
            field("email").val(null);
            $form.hide();
            showMessage("E-mail registrado com sucesso.", "bg-green");
          })
          .fail((xhr) => {
            const message = xhr.responseJSON && xhr.responseJSON.message;
            showMessage(message || "Falha ao registrar e-mail.", "bg-red");
            window.grecaptcha.reset(widget);
          })
          .always(() => {
            $button.attr("disabled", false);
          });
      };

      $button.on("click", submit);
      $form.on("keydown", "input", (event) => {
        if (event.key !== "Enter") return;

        event.preventDefault();
        submit();
      });
    });
  }
}

$(document).ready(() => {
  new Test();
});
